export { default } from './InfoCard';